/**
 * Tiny Prism wrapper for the Quick Start code blocks. Imports only the
 * grammars we actually render, then exposes highlight(code, lang) → HTML.
 * Prism escapes the output, so it is safe to dangerouslySetInnerHTML.
 */
import Prism from "prismjs";
import "prismjs/components/prism-bash";
import "prismjs/components/prism-json";
import "prismjs/components/prism-python";
import "prismjs/components/prism-rust";
import "prismjs/components/prism-go";
import "prismjs/components/prism-clike";
import "prismjs/components/prism-markup-templating";
import "prismjs/components/prism-php";

const ALIAS: Record<string, string> = {
  bash: "bash",
  sh: "bash",
  json: "json",
  javascript: "javascript",
  js: "javascript",
  python: "python",
  py: "python",
  rust: "rust",
  go: "go",
  php: "php",
};

export function highlight(code: string, lang?: string): string {
  const key = ALIAS[(lang ?? "").toLowerCase()];
  const grammar = key ? Prism.languages[key] : undefined;
  if (!grammar) {
    // No grammar — escape and return plain so the block still renders safely.
    return code
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");
  }
  return Prism.highlight(code, grammar, key!);
}
